import { Button, DialogContent, DialogFooter } from 'components';
import styled from 'styled-components';

export const ObjectionDialogContent = styled(DialogContent).attrs({
  className: 'max-w-md',
})``;

export const ObjectionOptionBox = styled.div.attrs({
  className: 'rounded-md border border-border p-4',
})``;

export const ObjectionOptionRow = styled.div.attrs({
  className: 'flex items-center gap-2',
})``;

export const ObjectionOptionHint = styled.p.attrs({
  className: 'pl-6 text-sm text-muted-foreground',
})``;

export const ObjectionDialogFooter = styled(DialogFooter).attrs({
  className: 'gap-2 sm:gap-2',
})``;

export const CancelButton = styled(Button).attrs({
  variant: 'secondary',
  className: 'w-full sm:w-auto',
})``;

export const SubmitObjectionButton = styled(Button).attrs({
  variant: 'destructive',
  className: 'w-full sm:w-auto',
})``;

export const ConfirmRevokeButton = styled(Button).attrs({
  className: 'w-full sm:w-auto',
})``;
